module.exports = __webpack_public_path__ + "img/compositing.bb0681df.png";